/**
 * api-订单管理
 */
import { post } from '@/utils/http'
// 获取订单列表/评价管理
export const apiGetIndentList = p => post('/Bindent/getIndentList.do', p)
export const apiGetIndentByUid = p => post('/Bindent/getIndentByUid.do', p)
export const apiGetIndentById = p => post('/Bindent/getIndentById.do', p)
// 改变订单
export const apiChangeIndent = p => post('/Bindent/changeIndent.do', p)
// 删除评价
export const apiDelMessage = p => post('/Bindent/delMessage.do', p)
// 提现记录列表
export const apiWithdrawalRecordList = p => post('/Bindent/withdrawalRecordList.do', p)
// 获取空闲的服务人员
export const apiGetServerList = p => post('/indent/getServerList.do', p)
export const apiGetAllServerList = p => post('/indent/getAllServerList.do', p)
export const apiGetJKServerList = p => post('/indent/getJKServerList.do', p)
// 获取服务人员的时间
export const apiGetServerWorkTime = p => post('/indent/getServerWorkTime.do', p)
// 指派服务人员
export const apiServerAssign = p => post('/BServer/serverAssign.do', p)
export const apiServerAssignJK = p => post('/BServer/serverAssignJK.do', p)
